import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import InternetIcon from "../../../Components/Icon-SVG/InternetIcon";
import AnalyserIcon from "../../../Components/Icon-SVG/AnalyserIcon";
import TableSpinnerIcon from "../../../Components/Icon-SVG/TableSpinnerIcon";

import { TriggerHunterboxHealthCheck } from "../../../store/actions/healthCheckActions";

const ICON_SIZE = {
  width: 20,
  height: 20,
};

const SERVICES = [
  {
    id: "broker",
    header: "Backend",
    stateKey: "brokerStatus",
    renderIcon: (color, width, height) => (
      <AnalyserIcon color={color} width={width} height={height} />
    ),
  },
  {
    id: "agenter",
    header: "Agenter",
    stateKey: "agenterStatus",
    renderIcon: (color, width, height) => (
      <InternetIcon color={color} width={width} height={height} />
    ),
  },
];

const HunterBoxHealth = () => {
  const dispatch = useDispatch();

  const healthState = useSelector((state) => state.healthCheck);
  const { hunterboxHealthLoading } = healthState;

  useEffect(() => {
    dispatch(TriggerHunterboxHealthCheck());
  }, [dispatch]);

  const refreshHandler = () => {
    dispatch(TriggerHunterboxHealthCheck());
  };

  return (
    <div className="hunterbox__services">
      <div className="hunterbox__services__header">
        <h2 className="hunterbox__services__header__heading">Services</h2>
        <div className="hunterbox__services__header__refresh" onClick={refreshHandler}>
          <TableSpinnerIcon
            className="hunterbox__services__spinner"
            customStyle={{ margin: "0", height: "20px" }}
            spin={hunterboxHealthLoading}
          />
        </div>
      </div>
      {SERVICES.map((service) => (
        <div className="hunterbox__services__block border" key={service.id}>
          <div className="hunterbox__services__block--icon">
            {service.renderIcon("white", ICON_SIZE.width, ICON_SIZE.height)}
          </div>
          <p className="hunterbox__services__block--text" style={{ color: "white" }}>
            {service.header}
          </p>
          <div className="hunterbox__services__block--signal">
            <b
              className={`hunterbox__services__block--signal--status ${healthState[service.stateKey] ? "open" : "close"}`}></b>
          </div>
        </div>
      ))}
    </div>
  );
};

export default HunterBoxHealth;
